//import liraries
import React from 'react';
import { View, Pressable, Text, TouchableOpacity,Linking } from 'react-native';
import CImage from './CImage';
import CText from './CText';
import CustomButton from './CustomButton';
import { CreateResponsiveStyle, DEVICE_SIZES } from 'rn-responsive-styles';
import CInput from './CInput';
import { COLORS, FONTS } from '../constant';
import CPanDetails from './CPanDetails';
import CView from './CView';

// create a component
const CServiceReqBoxView = (props) => {
  const screen = props?.screen || '';

  const renderkycScreen = () => {
    return (
      <View style={styles.kycUpdateBox}>
        <View>
          <CText.basicInformation>{'IMPORTANT UPDATE'}</CText.basicInformation>
          <CText.basicInformation style = {{color:"#9c1d25",marginTop:20 }}>{'FASTag KYC Process has changed'}</CText.basicInformation>
          <CText.certificateHeadlineText style = {{opacity : 0.6,marginTop:20, lineHeight:17}}>{'Transacting more than ₹ 10,000 per month?'}</CText.certificateHeadlineText>
          <CText.usedCarLoanUpto style = {{ lineHeight:17}}>{'Visit a Point of Sale (POS) FASTag Agent for biometric KYC \n verification. Thank you for your cooperation!'}</CText.usedCarLoanUpto>
          <TouchableOpacity
                  onPress={()=>props?.setTncModalVisible(true)} >
          <CText.certificateHeadlineText style ={{color : "#3a7ff5",marginTop:20, fontSize:15,textDecorationLine :"underline"}}>{'Locate nearby POS for biometric KYC '}</CText.certificateHeadlineText>

                  </TouchableOpacity>

        </View>
        <View>
        <View style={styles.infoWrapper}>
          <CImage.IconTip />
          <CView width={50}>
            <Text style={styles.disputeText}>{"If you transact less than \n ₹10,000 per month, no \n action needed."}</Text>
          </CView>
        </View>
        <View style  = {{marginTop:20, textAlign:"center"}}>
        <CText.usedCarLoanUpto style ={{fontSize: 10 ,lineHeight:14}}><Text style = {{color : "#9c1d25"}}>{"Trouble with POS?"}</Text>{" Email us at \n"}
        <TouchableOpacity onPress={() => Linking.openURL('mailto:etollservices@idfcfirstbank.com') }
      title="etollservices@idfcfirstbank.com"><Text style ={{textDecorationLine :"underline",color : "#3a7ff5"}}>{"etollservices@idfcfirstbank.com"}
          </Text></TouchableOpacity>{" with your \n registered mobile number, vehicle number,\n city and PIN code "}</CText.usedCarLoanUpto>
        </View>
        </View>
      </View>
     
    );
  };
  const renderPanDetails = () => {
    return (
      <>
        <View style={styles.rcInputViewStyle}>
          <CPanDetails
            onSubmit={props.onSubmitPress}
            type={'kycUpdate'}
          />
        </View>
      </>
    );
  };
  const styles = useStyles();
  return (
    <>
     {screen == 'KYC_UPDATE' ? (
      renderkycScreen()
     ) :(
      <View style={styles.enterRcViewStyle}>
        {props?.type == 'pan' ? (<Text style={{paddingLeft:20, paddingTop:10}}>{"PAN Verification"}</Text>): null}
        <View
          style={{
            flexDirection: 'row',
            marginTop: 10,
            minHeight:50
          }}>
          <CText.inputNoteText style={styles.noteTextStyle}>{props.descText}</CText.inputNoteText>
          <View style={{right:10,top:55,position:'absolute' }}>{props.selectedLayout == 'Update mobile number' ? <CImage.UpdateMobileImage /> : <CImage.KycUpdateImage />}</View>
        </View>
  
        <View style={styles.enterRcBodyViewStyle}>
          <View style={styles.rcViewStyle}>
            {props?.type == 'pan' ? (
              renderPanDetails()
            ) : (
              <View style={styles.rcInputViewStyle}>
                <CInput
                  value={props.value}
                  onChangeText={props.onChangeText}
                  onValidation={props.onValidation}
                  maxLength={10}
                  inputType='alpha-numeric'
                  pattern={'[a-z]{5}[0-9]{4}[a-z]{1}'}
                  placeHolder={props.placeHolder}
                  style={styles.inputStyle}
                />
              </View>
            )}
          </View>
        </View>
        <View style={styles.horizontalLine} />
        {props?.type == 'pan'?<></>  :
        <View style={styles.RCUpdate_UploadImageButtons}>
          <Pressable style={styles.RCUpdate_UploadImageSubmit}>
            <CustomButton
              text={'Submit'}
              onPress={!props.disable ? props.onSubmitPress : null}
              disable={props.disable}
            />
          </Pressable>
        </View> }
      </View>
      )}
    </>
  );
};

// define your styles
const useStyles = CreateResponsiveStyle(
  {
    infoWrapper: {
      width: 220,
      flexDirection: 'row',
      backgroundColor: COLORS.blue550,
      borderRadius: 10,
      padding: 15,
      marginTop: 12,
    },
    disputeText: {
      fontFamily: FONTS.InterBold,
      fontSize: 12,
      opacity:0.6,
      color: COLORS.black200,
    },
    container: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#2c3e50',
    },
    subContainer: {
      flexDirection: 'row',
      marginTop: 10,
    },
    RCUpdate_UploadImageReset_Text: {
      fontFamily: 'Inter',
      fontSize: 15,
      color: '#bd2d37',
    },
    RCUpdate_UploadImageReset: {
      width: 125,
      height: 35,
      alignItems: 'center',
      justifyContent: 'center',
      border: '2px solid #bd2d37',
      borderRadius: 16,
      marginRight: 10,
    },
    RCUpdate_UploadImageSubmit: {
      width: 200,
      height: 35,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#bd2d37',
      borderRadius: 16,
    },
    RCUpdate_UploadImageButtons: {
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
      marginTop: 15,
      marginRight: '10%',
    },
    horizontalLine: {
      height: 0.5,
      width: '100%',
      backgroundColor: '#ccd0d5',
      display: 'none',
      marginTop: 20,
    },
    enterRcViewStyle: {
      width: '100%',
      height: 250,
      borderRadius: 12.9,
      borderStyle: 'solid',
      borderWidth: 1,
      borderColor: '#ccd0d5',
    },
    kycUpdateBox:{
      width: "70%",
      height: 210,
      borderRadius: 12.9,
      borderStyle: 'solid',
      borderWidth: 1,
      borderColor: '#ccd0d5',
      paddingTop : 20 , paddingLeft:20, gap : 30,
      flexDirection: 'row',
    },
    enterRcBodyViewStyle: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    rcViewStyle: {
      flexDirection: 'row',
      marginLeft: 10,
      justifyContent: 'space-between',
      width: '50%',
    },
    rcNumberTextStyle: {
      fontFamily: 'Inter',
      fontSize: 12,
      fontWeight: 'normal',
      fontStyle: 'normal',
      lineHeight: 14.4,
      letterSpacing: 0.24,
      textAlign: 'left',
      color: '#66625f',
      marginRight: 10,
      marginTop: 10,
    },
    rcInputViewStyle: {
      width: 200,
      marginLeft: 20,
      marginTop: 5,
    },
    inputStyle: {
      width: 299,
      height: 36.5,
      borderRadius: 8.3,
      backgroundColor: 'rgba(0, 0, 0, 0)',
      borderStyle: 'solid',
      borderWidth: 2,
      borderColor: COLORS.white1,
      fontFamily: FONTS.InterMedium,
      fontSize: 16,
      lineHeight: 18,
      letterSpacing: 0.1,
      textAlign: 'left',
      color: COLORS.darkBlack,
      paddingLeft: 17,
      marginTop: 30,
    },
    noteTextStyle: {
      paddingLeft: 20,
      paddingRight: 40,
    },
  },
  {
    [DEVICE_SIZES.XS]: {
      RCUpdate_UploadImageButtons: {
        flexDirection: 'column',
        alignItems: 'start',
        marginLeft: 20,
        marginTop: 40,
        left: 0,
      },
      inputStyle: {
        width: 250,
      },

        enterRcViewStyle: {
      width: '96%',
      height: 280,
      borderRadius: 12.9,
      borderStyle: 'solid',
      borderWidth: 1,
      borderColor: '#ccd0d5',
    },
      kycUpdateBox:{
        height: "100%",
        flexDirection:"column",
        gap :0,
        width: "100%",
      },
      infoWrapper: {
        width: 220,
      },
      rcInputViewStyle: {
        width: 140,
        marginLeft: 5,
        marginTop: 40,
      },
      RCUpdate_UploadImageReset: {
        marginTop: 20,
      },
    },
  }
);

//make this component available to the app
export default CServiceReqBoxView;

